import {useEffect} from 'react';
import {UserFlowStep} from '../../Facade/UserFlow/BaseUserFlow';
import APIServer from '@taopix/taopix-core/dist/types/Service/APIServer';
import {useUserFlowState} from '../../Components/Context/UserFlow/UserFlowContext';
import {useUiState} from '../../Components/Context/UserInterface/UserInterfaceContext';
import {UserInterfaceActions} from '../../Components/Context/UserInterface/UserInterfaceActionTypes';
import {useSelector} from 'react-redux';
import {PerfectlyClearSelector} from '../../Selectors';
import {UserFlowType} from '../../Facade/UserFlow/UserFlowFacade';
import {DialogStatus, OrderCartMethod, OrderStatus} from '../../Enums';
import {useUserFeedback} from '../../Components/Context/UserFeedback/UserFeedbackContext';
import {UserFeedbackActions} from '../../Components/Context/UserFeedback/UserFeedbackActionTypes';
import {
  CoreInterface,
  OrderProjectArgs,
  OrderResponse,
  ReducerState,
} from '@taopix/taopix-core/dist/types/types';

export const useOrderObserver = (core: CoreInterface, server: APIServer) => {
  const ui = useUiState();
  const userFlow = useUserFlowState();
  const userFeedback = useUserFeedback();
  const perfectlyClear = useSelector(PerfectlyClearSelector);

  const isOrderStep =
    userFlow.isUserFlowActive(UserFlowType.Order) &&
    userFlow.isStepActive(UserFlowType.Order, UserFlowStep.Order);

  useEffect(() => {
    let controller;

    // User has reached the final step of OrderUserFlow.
    if (isOrderStep && !ui.state.busy) {
      ui.dispatch(UserInterfaceActions.setIsBusy(true));

      controller = new AbortController();
      core
        .get('stateManager')
        .call<OrderProjectArgs, ReducerState>('orderProject', {
          perfectlyClear,
        })
        .then(response => {
          const payload = response as ReducerState & OrderResponse;
          if (payload.proceedToCart) {
            if (OrderCartMethod.PostMessage === payload.cartData.method) {
              window[payload.cartData.postmessagejavascripttarget].postMessage(
                payload.cartData.data,
                payload.cartData.postmessagetargeturl
              );
            } else {
              if ('' !== payload.cartUrl) {
                window.location.href = payload.cartUrl;
              }
            }
          } else {
            if (OrderStatus.Upload === payload.status) {
              ui.dispatch(
                UserInterfaceActions.setDialogStatus({
                  submittedChangesNotification: DialogStatus.Open,
                })
              );
              ui.dispatch(UserInterfaceActions.setIsBusy(false));
            }
          }
        })
        .catch(error => {
          if (server.isCancel(error)) return;

          userFlow.setCurrentStep(`${UserFlowStep.Order}.${UserFlowStep.None}`);

          userFeedback.dispatch(
            UserFeedbackActions.setErrorUserFeedback({
              title: '',
              message: server.getErrorFromResponse(error),
              showHeader: true,
            })
          );
          ui.dispatch(UserInterfaceActions.setIsBusy(false));
        });
    }

    return () => {
      if (controller instanceof AbortController && !ui.state.busy) {
        //controller.abort();
      }
    };
  }, [isOrderStep]);

  return;
};
